var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.appendButtonDisabled") } },
    [
      _c("el-switch", {
        model: {
          value: _vm.optionModel.appendButtonDisabled,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "appendButtonDisabled", $$v)
          },
          expression: "optionModel.appendButtonDisabled",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }